<template>
  <div class="service-availability flex flex-col w-full">
    <span class="text-xs text-gray-500 mb-3">
      בחרו את השעות בהן ניתן לקבוע תור לשירות זה. השעות מוגבלות בנוסף לשעות הפעילות של נותן השירות. יום ללא שעות = השירות אינו ניתן להזמנה באותו היום.
    </span>
    <div
      v-for="day of orderedDays"
      :key="day"
      class="px-1 py-3 w-full border-b"
    >
      <div class="day flex flex-col w-full">
        <div class="day-header flex flex-row w-full justify-between items-center mb-2">
          <span class="font-medium">{{ weekDaysInHebrew[day] }}</span>
          <i class="pi pi-plus cursor-pointer" @click="addRange(day)" />
        </div>
        <div v-if="availability[day].length" class="flex flex-col gap-2 w-full">
          <div
            v-for="(range, idx) of availability[day]"
            :key="`${day}-${idx}`"
            class="working-hours flex justify-between items-center flex-row w-full"
          >
            <Select
              v-model="range.from"
              :options="hours"
              optionLabel="name"
              optionValue="value"
              class="w-full" />
            <divider />
            <Select
              v-model="range.to"
              :options="hours"
              optionLabel="name"
              optionValue="value"
              class="w-full" />
            <i class="pi pi-trash cursor-pointer mr-2 ml-1" @click="removeRange(day, idx)" />
          </div>
        </div>
        <div v-else class="text-sm text-gray-500 self-center py-1">
          יום ללא שעות
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { IAvailability } from '@torim-app/types';
import { Days, hours, weekDaysInHebrew } from '@torim-app/types';

import { PropType } from 'vue';
import Select from 'primevue/select';

const props = defineProps({
  // Parent guarantees all 7 weekday keys are initialized. The component mutates
  // the object in place (same pattern as the business Availability editor).
  availability: {
    type: Object as PropType<IAvailability>,
    required: true
  }
});

const orderedDays: Days[] = [
  Days.SUNDAY,
  Days.MONDAY,
  Days.TUESDAY,
  Days.WEDNESDAY,
  Days.THURSDAY,
  Days.FRIDAY,
  Days.SATURDAY
];

const addRange = (day: Days) => {
  const dayRanges = props.availability[day];
  const previous = dayRanges.length > 0 ? dayRanges[dayRanges.length - 1] : null;

  if (previous) {
    const toValue = typeof previous.to === 'string' ? previous.to : previous.to?.name;
    const toIndex = hours.findIndex(x => x.value === toValue);
    dayRanges.push({
      from: hours[toIndex >= 0 && toIndex < hours.length - 1 ? toIndex + 1 : toIndex].value,
      to: hours[toIndex >= 0 && toIndex < hours.length - 2 ? toIndex + 2 : hours.length - 1].value
    });
  } else {
    // Default to 09:00–17:00 (indexes 18 and 34 on a 30-min grid starting 00:00)
    dayRanges.push({ from: hours[18].value, to: hours[34].value });
  }
};

const removeRange = (day: Days, idx: number) => {
  props.availability[day].splice(idx, 1);
};
</script>

<style lang="scss" scoped>
.service-availability {
  .working-hours {
    .p-select {
      flex-grow: 1;
    }

    .p-divider {
      width: 0.5rem;
      margin: 0 0.5rem;
    }
  }
}
</style>
